import { DialogContent } from '@material-ui/core'
import MuiDialogContentText from '@material-ui/core/DialogContentText'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'

const DialogTitle = withStyles(() => ({
  root: {
    'font-family': 'Ubuntu',
    'font-size': '20px',
    'line-height': '1.2',
    'letter-spacing': '0.2px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
}))(MuiDialogTitle)

const DialogContentText = withStyles(() => ({
  root: {
    'font-family': 'Ubuntu',
    'font-size': '16px',
    'line-height': '1.5',
    'letter-spacing': '0.1px',
    color: 'rgba(0, 0, 0, 0.60)',
  },
}))(MuiDialogContentText)

const WalidacjaSuccessDialog = () => {
  return (
    <>
      <DialogTitle disableTypography={true}>
        Gratulujemy! Twoje e-Sprawozdanie jest poprawne
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Możesz teraz pobrać e-Sprawozdanie do pliku XML, a następnie przesłać
          je drogą elektroniczną do urzedu.
        </DialogContentText>
      </DialogContent>
    </>
  )
}

export default WalidacjaSuccessDialog
